import { C4Form } from './../c4-form';
import { Component, EventEmitter, Input, Output, Optional, Host } from '@angular/core';
import { C4InputInterface, C4Input, C4InputConfig, C4Option } from '../c4-input';

declare var module: any;

@Component({
  selector: 'c4-input-date',
  templateUrl: '../text/c4-input-text.html',
  styles: [`
		.control-label {
			font-weight: normal;
		}
	`],
})
export class C4InputDate extends C4Input implements C4InputInterface {
  @Input() config;
  @Input() name: string;
  @Input() tagId: string;
  @Input() value: string;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() prefix: string;
  @Input() suffix: string;

  type: string = 'date';

  constructor( @Optional() @Host() form: C4Form) {
    super(form);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/date/c4-input-date.ts